var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "#1F72CD",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5458 16.7L7 31.2813H14.8362L15.8077 28.9564H18.0282L18.9997 31.2813H27.6251V29.5069L28.3937 31.2813H32.8555L33.6241 29.4694V31.2813H51.5627L53.7439 29.0168L55.7863 31.2813L65 31.3L58.4336 24.0313L65 16.7H55.9292L53.8059 18.9226L51.8278 16.7H32.3129L30.6372 20.4636L28.9222 16.7H21.1023V18.414L20.2324 16.7H13.5458ZM40.3333 18.7706H50.6345L53.7851 22.1964L57.0373 18.7706H60.188L55.4009 24.0293L60.188 29.2274H56.8944L53.7438 25.7619L50.475 29.2274H40.3333V18.7706ZM42.8772 22.8469V20.9369V20.9351H49.3048L52.1095 23.9897L49.1806 27.061H42.8772V24.9758H48.4969V22.8469H42.8772ZM15.062 18.7706H18.8818L23.2236 28.6582V18.7706H27.4079L30.7615 25.86L33.8522 18.7706H38.0156V29.2336H35.4822L35.4616 21.0348L31.7682 29.2336H29.5019L25.7879 21.0348V29.2336H20.5761L19.5881 26.8879H14.2501L13.2641 29.2315H10.4717L15.062 18.7706ZM15.1616 24.7195L16.9203 20.5409L18.6769 24.7195H15.1616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.9aa92710a0dc00d4f040d103bb9e871e.svg";
export { ForwardRef as ReactComponent };